import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/voucher`,{params:searchParams});
    }

    get(id){
      return this.http.get(`${environment.baseUrl}/voucher/`+id);
    }

    edit(id,formData){
      return this.http.put(`${environment.baseUrl}/voucher/`+id,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/voucher`,formData);
    }

    delete(id){
      return this.http.delete(`${environment.baseUrl}/voucher/`+id);
    }

}